module.exports = __webpack_public_path__ + "media/images/japan/intro-picture-7604a296988b7d6f494bc376a576f6b0.png";